<template>
  <div class="select-head fx-s-center">

    <el-select v-model="activeIndustry" placeholder="请选择" filterable @change="selectHandle">
      <el-option v-for="(item, i) in allChainList" :key="`${item.secId}__${i}`" :label="item.secName" :value="item.secId"></el-option>
    </el-select>
    <el-tabs class="fx-full" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="item in tabOptions" :key="item.path" :label="item.label" :name="item.path" />
    </el-tabs>
    <span class="back-btn fx-none" @mouseenter="stroke='#1150FB'" @mouseleave="stroke='#86909C'" @click="$router.push('/zxk/industryChain')">
      <span class="mr-4">返回产业列表</span>
      <span class="cust-icon cust-icon-svg" title="">
        <svg viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="3-1-1.1-产业专题-产业概况" transform="translate(-1392.000000, -90.000000)">
              <g id="编组-3" transform="translate(1300.000000, 88.000000)">
                <g id="编组备份" transform="translate(92.000000, 2.000000)">
                  <rect id="矩形" fill="#1150FB" opacity="0" x="0" y="0" width="16" height="16"></rect>
                  <path d="M4.5,4 L10,4 C12.209139,4 14,5.790861 14,8 C14,10.209139 12.209139,12 10,12 L7,12" id="路径" :stroke="stroke" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round"></path>
                  <path
                    d="M5.05982141,3.46434959 L5.05982141,7.18121724 C5.05982141,7.23644571 5.01504988,7.28121724 4.95982141,7.28121724 L1.29868702,7.28121724 C1.24345854,7.28121724 1.19868702,7.23644571 1.19868702,7.18121724 C1.19868702,7.15495725 1.2090164,7.12975106 1.22744422,7.11104271 L4.88857861,3.39417506 C4.92733494,3.35482875 4.99064963,3.35435048 5.02999594,3.3931068 C5.04907725,3.411902 5.05982141,3.43756609 5.05982141,3.46434959 Z"
                    id="三角形" :fill="stroke" transform="translate(3.059821, 5.250771) rotate(-90.000000) translate(-3.059821, -5.250771) "></path>
                </g>
              </g>
            </g>
          </g>
        </svg></span>
    </span>
  </div>
</template>

<script>     
import { mapState } from 'vuex'
export default {
  name: 'headCondition',
  props: {

  },
  data() {
    return {
      activeIndustry: '',
      activeName: 'overview',
      tabOptions: [
        { label: '产业概况', path: 'overview' },
        { label: '产业图谱', path: 'map' },
        { label: '产业分析', path: 'analyze' },
        { label: '企业分布', path: 'distribution' },
        { label: '产业新闻', path: 'news' },
        { label: '产业政策', path: 'policy' },
      ],
      stroke: '#86909C'
    }
  },
  computed: {
    ...mapState({
      industryChain: state => state.asyncRoute.industryChain,
      theClassify: state => state.asyncRoute.theClassify,
      allChainList: state => state.asyncRoute.allChainList,
      chainIDMap: state => state.asyncRoute.chainIDMap,
    }),
    ID() {
      return this.$route?.query?.id
    },
    theChain() {
      return this.chainIDMap[this.ID]
    },
  },
  watch: {
    '$route': {
      deep: true,
      immediate: true,
      handler: function (val) {
        const { path } = val
        const lastSlashIndex = path.lastIndexOf('/')
        this.activeName = path.substring(lastSlashIndex + 1)
        this.activeIndustry = this.theChain ? this.ID : ''
      }
    },
    theChain() {
      this.activeIndustry = this.theChain ? this.ID : ''
    }
  },
  created() {

  },
  methods: {
    selectHandle(item) {
      this.$router.replace({ path: '/redirect' + `/zxk/industryChain/${this.activeName}`, query: { id: this.activeIndustry } })
      // this.$router.push({ path: `/zxk/industryChain/${this.activeName}`, query: { id: this.activeIndustry } })
    },
    handleClick() {
      this.$router.push({ path: `/zxk/industryChain/${this.activeName}`, query: { id: this.activeIndustry } })
    }
  },
}
</script>

<style scoped lang="scss">
.pad-16 {
  padding: 16px;
}
.select-head {
  ::v-deep {
    .el-dropdown {
      border-bottom: 1px solid #eeeeee;
      height: 39px;
      line-height: 39px;
    }
    .el-tabs__header {
      margin: 0;
    }
  }
  .back-btn {
    font-size: 0.9285714286rem;
    font-weight: 400;
    color: #86909c;
    cursor: pointer;
    border-bottom: 1px solid #eeeeee;
    height: 39px;
    line-height: 39px;

    &:hover {
      color: #1150fb;
    }
    .cust-icon {
      display: inline-block;
      color: inherit;
      font-style: normal;
      line-height: 0;
      text-align: center;
      text-transform: none;
      vertical-align: -0.125em;
      text-rendering: optimizeLegibility;
      -webkit-font-smoothing: antialiased;
      > svg {
        display: inline-block;
        width: 1em;
        height: 1em;
      }
    }
  }
}
</style>
